<div class="form-header">
  <span *ngIf="evaluation.id && evaluation.id > 0">Edit</span>
  <span *ngIf="!evaluation.id || evaluation.id === -1">Add</span>
  evaluation
</div>
<form class="form-view" [formGroup]="evaluationForm" (ngSubmit)="onSubmitForm(evaluationForm)">

  <div class="evaluations-container">
    <div class="evaluation-fields">
      <div class="field" >
        <mat-form-field appearance="fill">
          <mat-label>Key</mat-label>
          <input matInput required formControlName="providerKey" type="text"  name="providerKey">
        </mat-form-field>
      </div>
      <div class="field" >
          <mat-form-field appearance="fill">
            <mat-label>Amount</mat-label>
            <input matInput formControlName="evaluationAmt" type="number"  name="evaluationAmt">
          </mat-form-field>
      </div>
      <div class="field" >
        <mat-form-field appearance="fill">
          <mat-label>Quantity</mat-label>
          <mat-select name="evaluationUnit" formControlName="evaluationUnit">
            <mat-option *ngFor="let unit of ['weeks', 'months', 'years']" [value]="unit">{{unit}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field" >
        <mat-form-field appearance="fill">
          <mat-label>Window Weeks (Before and After)</mat-label>
          <input matInput formControlName="windowWeeks" type="number"  name="windowWeeks">
        </mat-form-field>
      </div>
      <div class="field" >
        <mat-slide-toggle name="perPatientFlag" formControlName="perPatientFlag">Per patient/family member?</mat-slide-toggle>
      </div>
     
    </div>
    <div class="criteria-table">
      <div class="table-label">Optional Criteria</div>
      <table class="criteria-table" mat-table [dataSource]="criteria" matSort (matSortChange)="changeSort($event)">
        <ng-container matColumnDef="attribute">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Attribute </th>
          <td mat-cell  *matCellDef="let criterion"> {{criterion.attribute }} </td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Value </th>
          <td mat-cell  *matCellDef="let criterion">{{ getDisplayValue(criterion) }} </td>
        </ng-container>

        <ng-container matColumnDef="remove">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Edit/Remove </th>
          <td mat-cell  *matCellDef="let criterion">  
            <button (click)="editCriterion(criterion)" mat-icon-button  [disabled]="showEditCriterion" type="button">
              <mat-icon>edit</mat-icon>
            </button>

            <button (click)="removeCriterion(criterion)" mat-icon-button  [disabled]="showEditCriterion" type="button">
              <mat-icon>delete</mat-icon>
            </button> 
          </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="criteriaColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: criteriaColumns;"></tr>
      </table>
      <div class="add-criterion" *ngIf="!showEditCriterion">
        <button type="button" (click)="editCriterion()" mat-icon-button  >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="showEditCriterion" class="criterion-edit-panel">
      <div class="criterion-edit-fields">
        <div class="field" >
          <mat-form-field appearance="fill">
            <mat-label>Attribute</mat-label>
            <mat-select name="attributeName" (selectionChange)="onChangeAttribute()" formControlName="attributeName">
              <mat-option *ngFor="let name of getSupportedAttributeNames()" [value]="name">{{name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="field" >
          <mat-form-field appearance="fill" *ngIf="isStringValue()">
            <mat-label>Value</mat-label>
            <mat-select name="attributeValue" formControlName="attributeValue">
              <mat-option *ngFor="let v of getAttributeValues()" [value]="v">{{v}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="field" >  
          <mat-form-field appearance="fill" *ngIf="isNumericValue()">
            <mat-label>Minimum</mat-label>
            <input matInput formControlName="minValue" type="number"  name="minValue">
          </mat-form-field>
        </div>
        <div class="field" >  
          <mat-form-field appearance="fill" *ngIf="isNumericValue()">
            <mat-label>Maximum</mat-label>
            <input matInput formControlName="maxValue" type="number"  name="maxValue">
          </mat-form-field>
        </div>
      </div>
      <div class="save-criterion" >
        <button type="button" (click)="saveCriterion()" [disabled]="!isValidCriterion()" mat-flat-button  >
          {{saveCriterionAction}}
        </button>
      </div>
    </div>
    <div class="button-container">
      <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button
        color="primary">Save</button>
      <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
    </div>
  </div>

</form>